export const MICROCERTIFICATE_MINIMUM_PROGRESS = 75;
export const HOURS_AFTER_FIRST_PROGRESS_TO_SHOW_PRESENTATION_MODAL = 12;
export const DAYS_AFTER_FIRST_PROGRESS_TO_STOP_SHOWING_PRESENTATION_MODAL = 30;
export const LOCAL_STORAGE_KEY = 'postgradMicrocertificate';
export const PRESENTATION_MODAL_EXHIBITION_HASH = '#postgrad-microcertificate-presentation';
